import api from "../services/apiService";

const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const get = async (url, params) => (await api.get(url, { headers: authHeaders(), params })).data;
const post = async (url, body) => (await api.post(url, body, { headers: authHeaders() })).data;
const put = async (url, body) => (await api.put(url, body, { headers: authHeaders() })).data;
const del = async (url) => (await api.delete(url, { headers: authHeaders() })).data;

export const fetchChatMe = () => get("/chat/me");
export const fetchChatUsers = () => get("/chat/users");

export const fetchConversations = () => get("/chat/conversations");
export const fetchConversation = (id) => get(`/chat/conversations/${id}`);
export const createDirectConversation = (userId) => post("/chat/conversations/direct", { userId });
export const createGroupConversation = ({ name, description, memberIds }) =>
  post("/chat/conversations/group", { name, description, memberIds });
export const updateGroupConversation = (id, changes) => put(`/chat/conversations/${id}`, changes);
export const addConversationMembers = (id, userIds) => post(`/chat/conversations/${id}/members`, { userIds });
export const removeConversationMember = (id, userId) => del(`/chat/conversations/${id}/members/${userId}`);
export const setConversationMemberRole = (id, userId, role) =>
  put(`/chat/conversations/${id}/members/${userId}`, { role });
export const setConversationMuted = (id, muted) => put(`/chat/conversations/${id}/mute`, { muted });
export const setConversationPinned = (id, pinned) => put(`/chat/conversations/${id}/pin`, { pinned });
export const hideConversation = (id) => post(`/chat/conversations/${id}/hide`);
export const deleteGroupConversation = (id) => del(`/chat/conversations/${id}`);
export const removeGroupPhoto = (id) => del(`/chat/conversations/${id}/avatar`);
export const uploadGroupPhoto = async (id, blob, onProgress) => {
  const form = new FormData();
  form.append("photo", blob, "group.png");
  const { data } = await api.post(`/chat/conversations/${id}/avatar`, form, {
    headers: authHeaders(),
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  });
  return data;
};

export const fetchMessages = (conversationId, { before, limit } = {}) =>
  get(`/chat/conversations/${conversationId}/messages`, { before, limit });
export const editChatMessage = (messageId, body) => put(`/chat/messages/${messageId}`, { body });
export const deleteChatMessage = (messageId) => del(`/chat/messages/${messageId}`);
export const toggleChatReaction = (messageId, emoji) => post(`/chat/messages/${messageId}/reactions`, { emoji });

export const searchChatMessages = (q, conversationId) => get("/chat/search", { q, conversationId });

export const uploadChatAttachment = async (file, onProgress, { durationMs } = {}) => {
  const form = new FormData();
  form.append("file", file);
  if (durationMs) form.append("durationMs", String(Math.round(durationMs)));
  const { data } = await api.post("/chat/attachments", form, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  });
  return data;
};

export const fetchAttachmentUrl = (attachmentId) => get(`/chat/attachments/${attachmentId}/url`);

export const pinChatMessage = (messageId) => post(`/chat/messages/${messageId}/pin`);
export const unpinChatMessage = (messageId) => del(`/chat/messages/${messageId}/pin`);
export const fetchPinnedMessages = (conversationId) => get(`/chat/conversations/${conversationId}/pins`);

export const fetchPushPublicKey = () => get("/chat/push/public-key");
export const savePushSubscription = (subscription) => post("/chat/push/subscriptions", { subscription });
export const deletePushSubscription = async (endpoint) =>
  (await api.delete("/chat/push/subscriptions", { headers: authHeaders(), data: { endpoint } })).data;
